export default __webpack_public_path__ + "static/media/Caliga Tergus.76e8da73.jpg";